<template>     
    <v-list subheader>        
      <slot></slot>      
      <v-list-tile :value="mapState.showGraticule"  @click="$store.myActions.UI_TOGGLE_GRATICULE_VISIBILITY(uiid)">
        <v-list-tile-avatar>
          <v-switch class="pt-4" :input-value="mapState.showGraticule"></v-switch>
        </v-list-tile-avatar>
        <v-list-tile-title>{{$t('Pilot.Tools.ShowGraticule')}}</v-list-tile-title>
      </v-list-tile>               
      <v-list-tile :value="measureTool == 'DISTANCE'" @click="$store.myActions.UI_SET_MEASURETOOL(measureTool == 'DISTANCE'?'NONE':'DISTANCE')">
        <v-list-tile-avatar>            
          <v-icon>mdi-ruler</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-title>{{$t('Pilot.Tools.MeasureDistance')}}</v-list-tile-title>
        <v-list-tile-action>
          <v-spacer />            
          <v-icon v-text="measureTool == 'DISTANCE'?'mdi-checkbox-marked':'mdi-checkbox-blank-outline'" />
        </v-list-tile-action>
      </v-list-tile>
      <v-list-tile :value="measureTool == 'BEARING'" @click="$store.myActions.UI_SET_MEASURETOOL(measureTool == 'BEARING'?'NONE':'BEARING')">
        <v-list-tile-avatar>            
          <v-icon>mdi-math-compass</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-title>{{$t('Pilot.Tools.Bearing')}}</v-list-tile-title>
        <v-list-tile-action>
          <v-spacer />            
          <v-icon v-text="measureTool == 'BEARING'?'mdi-checkbox-marked':'mdi-checkbox-blank-outline'" />
        </v-list-tile-action>
      </v-list-tile>
      <v-list-tile :value="measureTool == 'AREA'"  @click="$store.myActions.UI_SET_MEASURETOOL(measureTool == 'AREA'?'NONE':'AREA')">
        <v-list-tile-avatar><v-icon >mdi-ruler-square</v-icon></v-list-tile-avatar>
        <v-list-tile-title>{{$t('Pilot.Tools.MeasureArea')}}</v-list-tile-title>
        <v-list-tile-action>
          <v-spacer />
          <v-icon v-text="measureTool == 'AREA'?'mdi-checkbox-marked':'mdi-checkbox-blank-outline'" />
        </v-list-tile-action>
      </v-list-tile>
      <v-list-tile :value="measureTool == 'CIRCLE'" @click="$store.myActions.UI_SET_MEASURETOOL(measureTool == 'CIRCLE'?'NONE':'CIRCLE')">
        <v-list-tile-avatar><v-icon>mdi-circle-outline</v-icon></v-list-tile-avatar>
        <v-list-tile-title>{{$t('Pilot.Tools.MeasureCircle')}}</v-list-tile-title>
        <v-list-tile-action>
          <v-spacer />
          <v-icon v-text="measureTool == 'CIRCLE'?'mdi-checkbox-marked':'mdi-checkbox-blank-outline'" />
        </v-list-tile-action>
      </v-list-tile>  
      <v-list-tile :value="measureTool == 'PROFILE_DEPTH'" @click="$store.myActions.UI_SET_MEASURETOOL(measureTool == 'PROFILE_DEPTH'?'NONE':'PROFILE_DEPTH')">
        <v-list-tile-avatar><v-icon >mdi-chart-areaspline</v-icon></v-list-tile-avatar>
        <v-list-tile-title>{{$t('Pilot.Tools.MeasureDepthProfile')}}</v-list-tile-title>
        <v-list-tile-action>
          <v-spacer />
          <v-icon v-text="measureTool == 'PROFILE_DEPTH'?'mdi-checkbox-marked':'mdi-checkbox-blank-outline'" />
        </v-list-tile-action>
      </v-list-tile>    
      <coord-selector />
    </v-list>                
</template>
<script>
  import { mapGetters } from 'vuex'    
  import CoordSelector from '@/components/shared/CoordSelector'
  export default {    
  name: 'MapToolList',
  components:{CoordSelector},
   props:{    
     uiid:{
        type: String,
        required: true
     }
   }, 
   computed: {
       ...mapGetters([
         'uistatebyuiid',
         'measureTool'
        ]),
        //recupere le state de travail
        mapState(){          
          return this.uistatebyuiid(this.uiid)
        }
    },    
    methods: {
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>

</style>
